import PropTypes from "prop-types";
import { memo, useCallback } from "react";
import classNames from "classnames";
import "./MediaCarouselItem.scss";
import VideoPreviewPicture from "app/pages/.shared/Video/VideoPreviewPicture";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import { resolutionPropType } from "app/utils/propTypes";

const IMG_SIZES_LARGE = {
	large: { width: 500 },
	medium: { width: 500 },
	xlarge: { width: 500 },
};

const CLOUDINARY_OPTIONS = ["c_fill", "g_center"];

const MediaCarouselItem = ({
	photoUrl,
	resolution,
	photoThumbnail,
	videoPreviewUrl,
	title,
	isActive,
	onClick = () => {},
}) => {
	const handleClick = useCallback(() => {
		onClick(title);
	}, [title]);

	const mediaCarouselClass = classNames({
		"media-carousel-item": true,
		"media-carousel-item--active": isActive,
	});

	return (
		<div className={mediaCarouselClass}>
			<div className="media-carousel-item__photo" onClick={handleClick}>
				{videoPreviewUrl ? (
					<VideoPreviewPicture
						resolution={resolution}
						sizes={IMG_SIZES_LARGE}
						previewPicture={photoUrl ? photoUrl : videoPreviewUrl}
					/>
				) : (
					<BackgroundProgressiveImg
						sizes={IMG_SIZES_LARGE}
						cloudinaryOptions={CLOUDINARY_OPTIONS}
						src={photoUrl}
						thumbnail={photoThumbnail}
						offset={0}
						backgroundPosition="center"
					/>
				)}
				{title && (
					<div className="media-carousel-item__footer">
						<span className="media-carousel-item__title">{title}</span>
					</div>
				)}
			</div>
		</div>
	);
};

MediaCarouselItem.propTypes = {
	videoPreviewUrl: PropTypes.string,
	photoThumbnail: PropTypes.string,
	photoUrl: PropTypes.string,
	title: PropTypes.string,
	isActive: PropTypes.bool,
	onClick: PropTypes.func,
	resolution: resolutionPropType,
};

export default memo(MediaCarouselItem);
